import { gql } from '@apollo/client'

export default gql`
  mutation UpdateAccountNotification(
    $input: updateEmailNotificationSettingInput!
  ) {
    updateEmailNotificationSetting(input: $input)
  }
`
